import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=f1f8d53e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=f1f8d53e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f8d53e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1f8d53e')) {
      api.createRecord('f1f8d53e', component.options)
    } else {
      api.reload('f1f8d53e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=f1f8d53e&scoped=true&", function () {
      api.rerender('f1f8d53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bcd0yu2ryi1i/JS/comp/PopupBox.vue"
export default component.exports